import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";
import MoviesList from "../pages/movies/page";
import MovieDetail from "../pages/movies/detail/page";
import CommunityList from "../pages/community/page";
import CommunityDetail from "../pages/community/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/news", element: <NewsList /> },
      { path: "/news/detail/:id", element: <NewsDetail /> },
      { path: "/movies", element: <MoviesList /> },
      { path: "/movies/detail/:id", element: <MovieDetail /> },
      { path: "/community", element: <CommunityList /> },
      { path: "/community/detail/:id", element: <CommunityDetail /> },
      { path: "/about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;